import React, { useState } from "react";
import CoreValuesdetails from "./CoreValues-details";
import Dropdown from "./Dropdown";
import GlowButton from "./GlowButton";
import SquareCard from "./SquareCard";
import VerifiedMemberPoints from "./VerifiedMemberPoints";
import EthicsCode from "./EthicCodes";

const InternetIcon = "/assets/services/2/coreValueDetail/1.png";
const MapIcon = "/assets/services/2/coreValueDetail/2.png";
const MonarchIcon = "/assets/services/2/coreValueDetail/3.png";
const ProfitIcon = "/assets/services/2/coreValueDetail/4.png";

const icon1 = "/assets/services/2/Standard/1.png";
const icon2 = "/assets/services/2/Standard/2.png";
const icon3 = "/assets/services/2/Standard/3.png";
const icon4 = "/assets/services/2/Standard/4.png";
const icon5 = "/assets/services/2/Standard/5.png";

const EligibilityCriteria = () => {
    // 🟢 Track which section is open (null = none)
    const [visibleSection, setVisibleSection] = useState({ 1: false, 2: false, 3: false, 4: false });

    const toggleSectionVisibility = (sectionIndex) => {
        setVisibleSection((prev) => ({ ...prev, [sectionIndex]: !prev?.[sectionIndex] }));
    };

    const faqData = [
        {
            id: 1,
            title: "Emergency Contact Numbers",
            content: "All emergency contact numbers are clearly displayed within the facility and easily accessible to staff and members for immediate response in case of any incident.",
        },
        {
            id: 2,
            title: "Emergency Action Plan (EAP)",
            content: "Our Emergency Action Plan outlines step-by-step procedures for evacuation, medical emergencies, and fire safety, ensuring quick and coordinated action.",
        },
        {
            id: 3,
            title: "First Aid Kit",
            content: "Fully stocked first aid kits are available at designated points throughout the facility, regularly checked and replenished by trained staff.",
        },
        {
            id: 4,
            title: "Fire Extinguisher",
            content: "Fire extinguishers are installed in accessible locations and maintained according to safety standards, with staff trained in their proper use.",
        },
        {
            id: 5,
            title: "CCTV Surveillance",
            content: "Our premises are monitored 24/7 through CCTV cameras to ensure the safety and security of all members and staff.",
        },
        {
            id: 6,
            title: "Regular Equipment Maintenance",
            content: "All fitness and facility equipment undergo routine inspections and maintenance to ensure safety, performance, and hygiene.",
        },
        {
            id: 7,
            title: "Potable Drinking Water",
            content: "Clean, filtered drinking water is available throughout the facility to keep members hydrated during workouts.",
        },
        {
            id: 8,
            title: "Clean Changing Rooms & Washrooms",
            content: "Our changing rooms and washrooms are cleaned and sanitized multiple times a day to maintain a hygienic environment for all users.",
        },
        {
            id: 9,
            title: "Well-lit Exercise Areas",
            content: "All workout and common areas are well-lit to ensure visibility, safety, and comfort during exercise sessions.",
        },
    ];


    const aboutMember = [
        {
            name: "Legal Registration",
            title: "Legal Registration",
            alt: "Legal Registration",
            description: "Must be a registered business entity.",
            path: InternetIcon,
        },
        {
            name: "Valid ID Proof of Owner",
            title: "Valid ID Proof of Owner",
            alt: "Valid ID Proof of Owner",
            description: "Copy of PAN Card and Aadhaar Card.",
            path: MapIcon,
        },
        {
            name: "Latest Utility Bill",
            title: "Latest Utility Bill",
            alt: "Latest Utility Bill",
            description: "Electricity bill for verification of operational status.",
            path: MonarchIcon,
        },
        {
            name: "Ownership or Lease Proof",
            title: "Ownership or Lease Proof",
            alt: "Ownership or Lease Proof",
            description:
                "Provide rent/lease agreement for rented property or ownership documents for owned property.",
            path: ProfitIcon,
        },
    ];

    const operationalStandards = [
        {
            name: "Receptionist",
            title: "Receptionist",
            alt: "Receptionist",
            description: "Present during operating hours, able to communicate in at least the local language.",
            path: icon1,
        },
        {
            name: "Transparent Pricing",
            title: "Transparent Pricing",
            alt: "Transparent Pricing",
            description: "All membership and service charges clearly communicated.",
            path: icon2,
        },
        {
            name: "Receipts for All Payments",
            title: "Receipts for All Payments",
            alt: "Receipts for All Payments",
            description: "Mandatory for financial transparency.",
            path: icon3,
        },
        {
            name: "Prohibition on PEDs",
            title: "Prohibition on PEDs",
            alt: "Prohibition on PEDs",
            description: "No sale, storage, or promotion of steroids or performance-enhancing drugs.",
            path: icon4,
        },
        {
            name: "Visible Branding",
            title: "Visible Branding",
            alt: "Visible Branding",
            description: "Gym name displayed at the entrance with adequate illumination.",
            path: icon5,
        },
    ];
    const requiredChecklistItems = [
        "Business Registration Certificate.",
        "Trainer Certifications (all active trainers).",
        "Facility Photos/Videos (covering interiors, equipment, and safety measures).",
        "List of Equipment & Services Offered.",
        "Signed Compliance Statement with FWPI Code of Ethics.",
        "Proof of ownership or lease agreement.",
        "Owner's PAN and Aadhaar Card copies.",
        "Latest electricity bill.",
    ];

    const receiveChecklistItems = [
        "Certificate of Facility Approval (digital, with optional hard copy).",
        "Official Listing in the FWPI Approved Facilities Directory.",
        "FWPI Approved Facility Badge for branding, website, and marketing use.",
    ];

    const submitChecklistItems = [
        "Complete the FWPI Facility Approval Application (online or as provided).",
        "Upload all required documents, photos, and trainer details.",
        "FWPI Review & Verification – Our audit team will assess compliance with standards.",
        "Pay the Facility Approval Fee (as per category and size).",
    ];
    return (
        <div className="text-white font-sans py-16 px-4 md:px-10">
            <div className="mx-auto text-center flex flex-col justify-center items-center relative">
                {/* STEP 1 */}
                <GlowButton
                    text={"Step 1 - Eligibility Criteria"}
                    clickHandler={() => toggleSectionVisibility(1)}
                />
                <div className="top-[48px] left-1/2 transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>

                {!!visibleSection?.["1"] && (
                    <div className="animate-fade-in-down overflow-hidden transition-all duration-700 ease-out">
                        <section
                            className="bg-gradient-radial text-white border-2 overflow-hidden w-[100%] sm:w-[100%] sm:h-fit border-[#FFFFFF] lg:rounded-tl-[20px] lg:rounded-tr-[120px] lg:rounded-bl-[60px] lg:rounded-br-[120px] rounded-tl-[30px] rounded-tr-[12px] rounded-bl-[30px] rounded-br-[30px] items-center lg:items-start"
                        >
                            <div className="bg-gradient-radial py-5 md:py-16 px-3">
                                <div className="flex justify-center items-center flex-col w-[100%] mx-auto sm:pb-8 ">
                                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center">
                                        Meet the Eligibility Criteria
                                    </h2>
                                    <p className="w-[100%] mx-auto text-[14px] md:text-[20px] lg:text-[22px] xl:text-[24px]  font-normal text-neutral-400 mb-2 font-urbanist  italic  leading-[2] tracking-[2%] text-center">
                                        Before applying, your facility must fully comply with FWPI
                                        standards in the following areas
                                    </p>
                                </div>

                                <VerifiedMemberPoints
                                    mainContainerClass="py-0 lg:py-0"
                                    titleClass="text-xl"
                                    title='Legal & Administrative Requirements'
                                    items={aboutMember}
                                    isHideNumber={true}
                                />
                            </div>

                            <div className="bg-gradient-radial text-white px-8 py-0">
                                <h2 className="font-urbanist font-semibold text-[20px] sm:text-[24px] lg:text-[30px]  leading-[100%] text-center py-2 md:py-8">
                                    Staff & Trainer Qualifications
                                </h2>
                                <ul className="list-disc text-left list-outside space-y-6 font-urbanist font-light text-[14px] sm:text-[16px] lg:text-[20px] mx-auto max-w-4xl py-5 pl-6">
                                    <li>
                                        All trainers must be{" "}
                                        <span className="font-semibold">18 years or older</span>{" "}
                                        with valid ID proof (Aadhaar or Voter ID).
                                    </li>
                                    <li>
                                        Minimum{" "}
                                        <span className="font-semibold">10+2 qualification </span>{" "}
                                        in any stream.
                                    </li>
                                    <li>
                                        <span className="font-semibold">
                                            {" "}
                                            Recognised Fitness/Personal Trainer Certification
                                        </span>
                                        (mandatory).
                                    </li>
                                    <li>
                                        <span className="font-semibold">
                                            First Aid CPR/AED Certification{" "}
                                        </span>
                                        from a recognised/accredited institute.
                                    </li>
                                    <li>
                                        Trainers must be{" "}
                                        <span className="font-semibold">
                                            trained in equipment usage, safety protocols, and
                                            maintenance.
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <EthicsCode
                                mainContainerClass="py-4 lg:py-4"
                                titleClass="text-xl"
                                title={`Safety, Hygiene & Emergency Preparedness`}
                                items={faqData}
                            />

                            <div className="pb-5 sm:pb-20">
                                <VerifiedMemberPoints
                                    title='Operational Standards'
                                    items={operationalStandards}
                                />
                                {/* <CoreValuesdetails values={operationalStandards} /> */}
                            </div>
                        </section>

                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                    </div>
                )}

                {/* STEP 2 */}
                <GlowButton
                    text={"Step 2 - Required Documents"}
                    clickHandler={() => toggleSectionVisibility(2)}
                />
                <div className="w-full justify-center items-center flex">
                    <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                </div>
                {!!visibleSection?.["2"] && (
                    <div className="animate-fade-in-down overflow-hidden transition-all duration-700 ease-out">
                        <section
                            className="bg-gradient-radial text-white border-2 overflow-hidden w-[100%] sm:w-[100%] sm:h-fit border-[#FFFFFF] rounded-tl-[12px] rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px] lg:rounded-tl-[120px] lg:rounded-tr [20px] lg:rounded-br-[60px] lg:rounded-bl-[120px] items-center lg:items-start"
                        >
                            {/* Step 2 ke content yahan daalna */}

                            <div className="py-6 w-[90vw]">
                                <div className="flex justify-center items-center flex-col w-[100%] mx-auto   ">
                                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center">
                                        Prepare Required Documents
                                    </h2>
                                    <p className="w-[100%] mx-auto text-[14px] md:text-[20px] lg:text-[22px] xl:text-[24px]  font-normal text-neutral-400 mb-2 font-urbanist  italic  leading-[2] tracking-[2%] text-center px-5 md:px-0">
                                        Gather and prepare the following for submission
                                    </p>
                                </div>

                                <div>
                                    <div className=" text-[#E1E1E1D6] p-8 font-sans">
                                        <ul className="list-disc text-left list-outside space-y-6 font-urbanist font-light sm:font-semibold  text-[14px] sm:text-[16px] lg:text-[20px] mx-auto max-w-4xl px-4 pl-6">
                                            {requiredChecklistItems.map((item, index) => (
                                                <li key={index} className="mb-4 text-lg ">
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                    </div>
                )}

                {/* STEP 3 */}
                <GlowButton
                    text={"Step 3 - Submit Your Application"}
                    clickHandler={() => toggleSectionVisibility(3)}
                />
                <div className="w-full justify-center items-center flex">
                    <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                </div>
                {!!visibleSection?.["3"] && (
                    <div className="animate-fade-in-down overflow-hidden transition-all duration-700 ease-out">

                        <section
                            className="bg-gradient-radial text-white border-2 overflow-hidden w-[100%] sm:w-[100%] sm:h-fit border-[#FFFFFF] rounded-tl-[12px] rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px] lg:rounded-tl-[120px] lg:rounded-tr-[20px] lg:rounded-br-[60px] lg:rounded-bl-[120px] items-center lg:items-start"
                        >
                            {/* Step 2 ke content yahan daalna */}

                            <div className="py-6 w-[90vw] transition-all duration-[1s] md:py-6 px-4">
                                <div className="flex justify-center items-center flex-col w-[100%] mx-auto  sm:pb-8 ">
                                    <h2 className="text-3xl md:text-3xl font-semibold text-white text-center">
                                        Submit Your Application
                                    </h2>
                                </div>

                                <div>
                                    <div className="text-[#E1E1E1D6] px-8 py-2 font-sans">
                                        <ul className="list-decimal text-left list-outside space-y-6 font-urbanist font-semibold mx-auto max-w-4xl">
                                            {submitChecklistItems.map((step, index) => (
                                                <li key={index} className="fwpi-list-item text-md">
                                                    {step}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                    </div>
                )}

                {/* STEP 4 */}
                <GlowButton
                    text={"Step 4 - Receive Your Certification"}
                    clickHandler={() => toggleSectionVisibility(4)}
                />

                {!!visibleSection?.["4"] && (
                    <div className="animate-fade-in-down overflow-hidden transition-all duration-700 ease-out">
                        <div className="w-full justify-center items-center flex">
                            <div className="transform -translate-x-1/2 w-0 h-10 border-l-2 border-dotted border-gray-400"></div>
                        </div>
                        <section
                            className="bg-gradient-radial text-white border-2 overflow-hidden w-[100%] sm:w-[100%] sm:h-fit border-[#FFFFFF]  rounded-tl-[12px] rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px] lg:rounded-tl-[120px] lg:rounded-tr-[20px] lg:rounded-br-[60px] lg:rounded-bl-[120px] items-center lg:items-start"
                        >
                            {/* Step 2 ke content yahan daalna */}

                            <div className="py-6 w-[90vw] transition-all duration-[1s]">
                                <div className="flex justify-center items-center flex-col w-[100%] mx-auto   ">
                                    <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-white text-center">
                                        Prepare Required Documents
                                    </h2>
                                    <p className="w-[100%] mx-auto text-[14px] md:text-[20px] lg:text-[22px] xl:text-[24px]  font-normal text-neutral-400 mb-2 font-urbanist  italic  leading-[2] tracking-[2%] text-center px-5 md:px-0">
                                        Gather and prepare the following for submission
                                    </p>
                                </div>

                                <div className="p-8 font-sans">
                                    <ul className="list-disc text-left list-outside space-y-6  font-urbanist font-light sm:font-semibold text-[14px] sm:text-[16px] lg:text-[20px] mx-auto max-w-4xl px-4 pl-6">
                                        {receiveChecklistItems.map((item, index) => (
                                            <li key={index} className="mb-4 text-lg ">
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </section>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EligibilityCriteria;
